import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "choose__color-list" }
const _hoisted_2 = ["value", "checked", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_block_ui = _resolveComponent("app-block-ui")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createBlock(_component_app_block_ui, { blocked: _ctx.blocked }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.preparedOptions, (option) => {
          return (_openBlock(), _createElementBlock("span", {
            class: "choose__color",
            key: option.reference
          }, [
            _withDirectives((_openBlock(), _createElementBlock("span", {
              class: _normalizeClass(["cr__color tooltip__info", {
                        'dark-color': !option.isLight,
                        'light-color': option.isLight,
                    }]),
              style: _normalizeStyle({ backgroundColor: option.hex })
            }, [
              _createElementVNode("input", {
                type: "checkbox",
                name: "color",
                value: option.hex,
                checked: _ctx.isOptionSelected(option),
                onClick: ($event: any) => (_ctx.toggleOption(option))
              }, null, 8, _hoisted_2)
            ], 6)), [
              [_directive_tippy, {
                        content:
                            option.label.slice(0, 1).toUpperCase() +
                            option.label.slice(1) +
                            ': ' +
                            option.counter,
                    }]
            ])
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["blocked"]))
}